import React from 'react';

import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter, ModalHeader } from '@qality/common-components';

type Props = {
  showModal: boolean;
  onClose: () => void;
};

export const NoPermissionToAddIssueTypeModal: React.FC<Props> = ({
  onClose,
  showModal,
}: Props) => {
  return (
    <ModalTransition>
      {showModal && (
        <Modal
          onClose={onClose}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEscapePress={false}
          shouldScrollInViewport
        >
          <ModalHeader
            appearance='warning'
            title='You don’t have permission to add/remove issue type'
          />
          <ModalBody>
            To add/remove the QAlity Test issue type, you need the Jira
            administrator level permission. Contact your Jira administrator to
            complete this action.
          </ModalBody>
          <ModalFooter>
            <Button appearance='warning' onClick={onClose}>
              OK
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
